import React from 'react';

import _ from 'lodash';

class Intercom extends React.Component {
    componentDidMount() {
        const { appID, ...otherProps } = this.props;
        if (!appID) {
            return;
        }
        if (!window.Intercom) {
            (function (w, d, id, s, x) {
                function i() {
                    i.c(arguments);
                }

                i.q = [];
                i.c = function (args) {
                    i.q.push(args);
                };
                w.Intercom = i;
                s = d.createElement('script');
                s.async = 1;
                s.src = 'https://widget.intercom.io/widget/' + id;
                x = d.getElementsByTagName('script')[0];
                x.parentNode.insertBefore(s, x);
            })(window, document, appID);
        }
        window.intercomSettings = {
            ...otherProps,
            app_id: appID,
            custom_launcher_selector: '.ChatSupportButton'
        };
        if (window.Intercom) {
            window.Intercom('boot', otherProps);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { appID, ...otherProps } = nextProps;
        if (_.isEqual(nextProps, this.props)) {
            return;
        }
        window.intercomSettings = { ...otherProps, app_id: appID };
        window.Intercom('update', otherProps);
    }

    shouldComponentUpdate() {
        return false;
    }

    componentWillUnmount() {
        if (!window.Intercom) return;
        window.Intercom('shutdown');
        delete window.Intercom;
    }

    render() {
        return null;
    }
}

export default Intercom;
